module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_Transition_00104.439a3a08.png";